import React from 'react'
import { Switch, Route } from 'react-router-dom'
import ToolsLayout from './ToolsLayout'
import ToolsIndex from './ToolsIndex'
import CpfGenerator from './CpfGenerator'
import UnitConverter from './UnitConverter'
import NameDrawer from './NameDrawer'
import BingoGenerator from './BingoGenerator'
import PasswordGenerator from './PasswordGenerator'
import UuidGenerator from './UuidGenerator'
import LoremIpsumGenerator from './LoremIpsumGenerator'
import FakeDataGenerator from './FakeDataGenerator'
import TestCardGenerator from './TestCardGenerator'
import Base64UrlEncoder from './Base64UrlEncoder'
import ColorConverter from './ColorConverter'
import QrCodeGenerator from './QrCodeGenerator'
import BusinessCardGenerator from './BusinessCardGenerator'
import WifiQrGenerator from './WifiQrGenerator'
import AgeCalculator from './AgeCalculator'
import CompoundInterestCalculator from './CompoundInterestCalculator'
import DecisionWheel from './DecisionWheel'
import CoinDiceRoller from './CoinDiceRoller'
import CltCalculator from './CltCalculator'
import SecretSantaLink from './SecretSantaLink'
import SecretSantaReveal from './SecretSantaReveal'
import ImageCompressor from './ImageCompressor'
import BurnMessageCreate from './BurnMessageCreate'
import BurnMessageReveal from './BurnMessageReveal'
import JsonFormatter from './JsonFormatter'
import RegexTester from './RegexTester'
import MockApiGenerator from './MockApiGenerator'
import CronExplainer from './CronExplainer'
import TextDiff from './TextDiff'
import ContrastChecker from './ContrastChecker'
import NetSalaryCalculator from './NetSalaryCalculator'
import FinancingSimulator from './FinancingSimulator'
import ResumeBuilder from './ResumeBuilder'
import ColorPaletteGenerator from './ColorPaletteGenerator'
import UrlShortener from './UrlShortener'
import UrlShortenerStats from './UrlShortenerStats'
import SuspiciousLinkChecker from './SuspiciousLinkChecker'
import FileShareCreate from './FileShareCreate'
import FileShareDownload from './FileShareDownload'
import DocumentValidator from './DocumentValidator'
import UnixTimestampConverter from './UnixTimestampConverter'
import HashGenerator from './HashGenerator'
import GitignoreGenerator from './GitignoreGenerator'
import PasswordStrengthChecker from './PasswordStrengthChecker'
import LotteryNumberGenerator from './LotteryNumberGenerator'
import InstallmentSimulator from './InstallmentSimulator'
import PricingCalculator from './PricingCalculator'
import CharacterCounter from './CharacterCounter'
import ShoppingListCreate from './ShoppingListCreate'
import ShoppingListView from './ShoppingListView'
import FocusTimer from './FocusTimer'
import NumberDrawer from './NumberDrawer'
import FileConverter from './FileConverter'
import WebhookTesterCreate from './WebhookTesterCreate'
import WebhookTesterView from './WebhookTesterView'
import BingoRoomCreate from './BingoRoomCreate'
import BingoRoomMaster from './BingoRoomMaster'
import BingoRoomJoin from './BingoRoomJoin'
import PlanningPokerCreate from './PlanningPokerCreate'
import PlanningPokerMaster from './PlanningPokerMaster'
import PlanningPokerJoin from './PlanningPokerJoin'
import RetroBoardCreate from './RetroBoardCreate'
import RetroBoardMaster from './RetroBoardMaster'
import RetroBoardView from './RetroBoardView'
import TournamentCreate from './TournamentCreate'
import TournamentMaster from './TournamentMaster'
import TournamentView from './TournamentView'

const ToolsRoutes = () => (
  <ToolsLayout>
    <Switch>
      <Route exact path="/ferramentas" component={ToolsIndex} />
      <Route path="/ferramentas/gerador-cpf-cnpj" component={CpfGenerator} />
      <Route
        path="/ferramentas/conversor-unidades"
        component={UnitConverter}
      />
      <Route path="/ferramentas/sorteio-de-nomes" component={NameDrawer} />
      <Route
        path="/ferramentas/gerador-de-bingo"
        component={BingoGenerator}
      />
      <Route
        path="/ferramentas/gerador-de-senha"
        component={PasswordGenerator}
      />
      <Route path="/ferramentas/gerador-uuid" component={UuidGenerator} />
      <Route
        path="/ferramentas/lorem-ipsum"
        component={LoremIpsumGenerator}
      />
      <Route
        path="/ferramentas/gerador-dados-fake"
        component={FakeDataGenerator}
      />
      <Route
        path="/ferramentas/gerador-cartao-teste"
        component={TestCardGenerator}
      />
      <Route
        path="/ferramentas/codificador-base64-url"
        component={Base64UrlEncoder}
      />
      <Route
        path="/ferramentas/conversor-de-cores"
        component={ColorConverter}
      />
      <Route
        path="/ferramentas/gerador-qrcode"
        component={QrCodeGenerator}
      />
      <Route
        path="/ferramentas/cartao-visita-digital"
        component={BusinessCardGenerator}
      />
      <Route path="/ferramentas/qrcode-wifi" component={WifiQrGenerator} />
      <Route
        path="/ferramentas/calculadora-de-idade"
        component={AgeCalculator}
      />
      <Route
        path="/ferramentas/calculadora-juros-compostos"
        component={CompoundInterestCalculator}
      />
      <Route
        path="/ferramentas/roleta-de-decisao"
        component={DecisionWheel}
      />
      <Route
        path="/ferramentas/cara-ou-coroa-dado"
        component={CoinDiceRoller}
      />
      <Route
        path="/ferramentas/calculadora-rescisao-clt"
        component={CltCalculator}
      />
      <Route
        exact
        path="/ferramentas/amigo-secreto/revelar"
        component={SecretSantaReveal}
      />
      <Route
        path="/ferramentas/amigo-secreto"
        component={SecretSantaLink}
      />
      <Route
        path="/ferramentas/compressor-de-imagem"
        component={ImageCompressor}
      />
      <Route
        exact
        path="/ferramentas/texto-temporario/ler"
        component={BurnMessageReveal}
      />
      <Route
        path="/ferramentas/texto-temporario"
        component={BurnMessageCreate}
      />
      <Route
        path="/ferramentas/formatador-json"
        component={JsonFormatter}
      />
      <Route
        path="/ferramentas/testador-regex"
        component={RegexTester}
      />
      <Route
        path="/ferramentas/gerador-mock-api"
        component={MockApiGenerator}
      />
      <Route
        path="/ferramentas/explicador-cron"
        component={CronExplainer}
      />
      <Route path="/ferramentas/comparador-de-texto" component={TextDiff} />
      <Route
        path="/ferramentas/verificador-contraste"
        component={ContrastChecker}
      />
      <Route
        path="/ferramentas/calculadora-salario-liquido"
        component={NetSalaryCalculator}
      />
      <Route
        path="/ferramentas/simulador-financiamento"
        component={FinancingSimulator}
      />
      <Route
        path="/ferramentas/gerador-curriculo"
        component={ResumeBuilder}
      />
      <Route
        path="/ferramentas/paleta-de-cores"
        component={ColorPaletteGenerator}
      />
      <Route
        exact
        path="/ferramentas/encurtador-url"
        component={UrlShortener}
      />
      <Route
        path="/ferramentas/encurtador-url/:id"
        component={UrlShortenerStats}
      />
      <Route
        path="/ferramentas/validador-cpf-cnpj"
        component={DocumentValidator}
      />
      <Route
        path="/ferramentas/conversor-unix-timestamp"
        component={UnixTimestampConverter}
      />
      <Route
        path="/ferramentas/gerador-de-hash"
        component={HashGenerator}
      />
      <Route
        path="/ferramentas/gerador-gitignore"
        component={GitignoreGenerator}
      />
      <Route
        path="/ferramentas/verificador-forca-senha"
        component={PasswordStrengthChecker}
      />
      <Route
        path="/ferramentas/numeros-da-sorte"
        component={LotteryNumberGenerator}
      />
      <Route
        path="/ferramentas/simulador-parcelamento-cartao"
        component={InstallmentSimulator}
      />
      <Route
        path="/ferramentas/calculadora-precificacao"
        component={PricingCalculator}
      />
      <Route
        path="/ferramentas/contador-de-caracteres"
        component={CharacterCounter}
      />
      <Route
        exact
        path="/ferramentas/lista-de-compras"
        component={ShoppingListCreate}
      />
      <Route
        path="/ferramentas/lista-de-compras/:id"
        component={ShoppingListView}
      />
      <Route path="/ferramentas/timer-de-foco" component={FocusTimer} />
      <Route path="/ferramentas/sorteador-de-numeros" component={NumberDrawer} />
      <Route path="/ferramentas/conversor-de-arquivos" component={FileConverter} />
      <Route
        exact
        path="/ferramentas/webhook-tester"
        component={WebhookTesterCreate}
      />
      <Route
        path="/ferramentas/webhook-tester/:id"
        component={WebhookTesterView}
      />
      <Route
        exact
        path="/ferramentas/bingo-ao-vivo"
        component={BingoRoomCreate}
      />
      <Route
        exact
        path="/ferramentas/bingo-ao-vivo/:id/mestre"
        component={BingoRoomMaster}
      />
      <Route
        path="/ferramentas/bingo-ao-vivo/:id"
        component={BingoRoomJoin}
      />
      <Route
        exact
        path="/ferramentas/planning-poker"
        component={PlanningPokerCreate}
      />
      <Route
        exact
        path="/ferramentas/planning-poker/:id/mestre"
        component={PlanningPokerMaster}
      />
      <Route
        path="/ferramentas/planning-poker/:id"
        component={PlanningPokerJoin}
      />
      <Route
        exact
        path="/ferramentas/retro-ao-vivo"
        component={RetroBoardCreate}
      />
      <Route
        exact
        path="/ferramentas/retro-ao-vivo/:id/mestre"
        component={RetroBoardMaster}
      />
      <Route
        path="/ferramentas/retro-ao-vivo/:id"
        component={RetroBoardView}
      />
      <Route
        exact
        path="/ferramentas/campeonato-ao-vivo"
        component={TournamentCreate}
      />
      <Route
        exact
        path="/ferramentas/campeonato-ao-vivo/:id/mestre"
        component={TournamentMaster}
      />
      <Route
        path="/ferramentas/campeonato-ao-vivo/:id"
        component={TournamentView}
      />
      <Route
        path="/ferramentas/verificador-link-suspeito"
        component={SuspiciousLinkChecker}
      />
      <Route
        exact
        path="/ferramentas/compartilhar-arquivo"
        component={FileShareCreate}
      />
      <Route
        path="/ferramentas/compartilhar-arquivo/:id"
        component={FileShareDownload}
      />
    </Switch>
  </ToolsLayout>
)

export default ToolsRoutes
